<!--
   Created by qing on 2021/7/3
   Des:
-->
<template>

  <van-cell class="ry-form__video">
    <template slot="title">
      <span class="title">{{current.title}}</span>
      <span style="float: right; color: #4260FA;" @click="show = true">倍数</span>
    </template>
    <template slot="label">

      <template v-if="current.fieldHint">
        <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
        <div
          v-else
          class="ql-editor"
          v-html="current.fieldHint">
        </div>
      </template>

      <div
        class="video-container"
        style="width: 100%';">
        <video
          id="formItemVideo"
          :style="videoStyle"
          :src="videoSrc"
          :autoplay="current.autoplay"
          controls
          preload="metadata"
          :poster="current.coverUrl">
          <source type="video/mp4" :src="videoSrc">
        </video>

        <van-action-sheet
          get-container="body"
          v-model="show"
          :actions="actions"
          @select="onSelect" />
      </div>
    </template>

  </van-cell>

</template>

<script>
  import {DEFAULT_VALUE__CUSTOM} from "../types";
  import {current} from './mixin'

  export default {
    mixins: [current],
    data() {
      return {
        show: false,
        actions: [
          {
            name: '0.5倍',
            value: 0.5
          },
          {
            name: '1倍',
            value: 1
          },
          {
            name: '1.25倍',
            value: 1.25
          },
          {
            name: '1.5倍',
            value: 1.5
          },
          {
            name: '2倍',
            value: 2
          },
          {
            name: '2.5倍',
            value: 2.5
          },
          {
            name: '3倍',
            value: 3
          }
        ]
      }
    },
    created() {
    },
    computed: {

      videoSrc() {
        if (this.current.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
          return this.current.defaultValue.customValue
        } else {
          return this.current.value
        }
      },

      videoStyle() {
        const width = '100%'
        const height = `auto`
		const borderRadius = '4px'

        return {
          width,
          height,
		  borderRadius
        }
      }
    },
    methods: {
      onSelect(item) {
        const video = document.getElementById('formItemVideo')
        video.playbackRate = item.value
        this.show = false
      }
    }
  }
</script>

<style lang="less">
  .ry-form__item-video {

    .iframe-container {

    }
  }
</style>
